import React from 'react'
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Container from '@material-ui/core/Container';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import logo from '../assets/logo.svg';
import { Link } from "react-router-dom";


function HideOnScroll(props) {
    const { children, window } = props;
    const trigger = useScrollTrigger({ target: window ? window() : undefined });
  
    return (
      <Slide appear={false} direction="down" in={!trigger}>
        {children}
      </Slide>
    );
  }
  HideOnScroll.propTypes = {
    children: PropTypes.element.isRequired,
    window: PropTypes.func,
  };

  
const Header = (props) => {


  const [menuActive, setMenuActive] = React.useState(false);
  
  const handleNavOpen = () => {
    menuActive ? setMenuActive(false) : setMenuActive(true);
    console.log('click');
  };
  const handleScrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    menuActive ? setMenuActive(false) : setMenuActive(true);

  };

  return (
    <div>
          <CssBaseline />
      <HideOnScroll {...props}>
        <AppBar className='header'>
            <Container>
            <Grid item xs={7} style={{
                textAlign:'left'
            }}>
                <Link to="/"><img src={logo} alt="Logo" /></Link>
            </Grid>
            <Grid item xs={9}>
                <div className={menuActive ? 'hambActive hamb' : 'hamb'} onClick={handleNavOpen}>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              <nav className={menuActive ? 'menuActive menuDiv' : 'menuDiv'}>
                <Link to="/" onClick={handleScrollUp}>Inicio</Link>
                <Link to="namaste" onClick={handleScrollUp}>Namasté</Link>
                <Link to="casazen" onClick={handleScrollUp}>Casa Zen</Link>
                <Link to="lasonada" onClick={handleScrollUp}>La Soñada</Link>
              </nav>

            </Grid>
            </Container>
        </AppBar>
      </HideOnScroll>

    </div>
  )
}

export default Header